import { DatePicker } from 'antd';
import classNames from 'classnames';
import dayjs, { Dayjs } from 'dayjs';
import { useContext, useState, useEffect } from 'react';

import AuthContext from '../../contexts/Auth/AuthContext';
import { getDateWithoutTime } from '../../helpers/dates';
import { FormInputWrapper } from '../old';

const todayDay = dayjs(getDateWithoutTime(new Date()));
const hundredYearsAgo = dayjs(getDateWithoutTime(new Date())).subtract(100, 'years');
const hundredYearsLater = dayjs(getDateWithoutTime(new Date())).add(100, 'years');

interface Props {
  label?: string;
  placeholder?: string;
  format?: string;
  value: Nullable<Dayjs>;
  name: string;
  minDate?: Dayjs;
  maxDate?: Dayjs;
  maxDateToday?: boolean;
  minDateToday?: boolean;
  minDateBirth?: boolean;
  required?: boolean;
  disabled?: boolean;
  onChange: (date: Nullable<Dayjs>) => void;
  isValidateAllow?: boolean;
}

export const InputDateAnt: React.FC<Props> = ({
  label,
  value,
  name,
  minDate,
  maxDate,
  placeholder = 'дд.мм.рррр',
  format = 'DD.MM.YYYY',
  minDateToday = false,
  maxDateToday = false,
  minDateBirth = false,
  required = false,
  disabled = false,
  isValidateAllow = false,
  onChange,
}) => {
  const [inputError, setInputError] = useState<string>('');

  const { userData } = useContext(AuthContext);

  useEffect(() => {
    if (value) {
      validateField(value);
    }
  }, [value]);

  useEffect(() => {
    if (isValidateAllow) {
      validateField(value);
    }
  }, [isValidateAllow, value]);

  const validateField = (eventValue: Nullable<Dayjs>): void => {
    if (required && !eventValue?.isValid()) {
      setInputError('Необхідно заповнити поле');
      return;
    }

    setInputError('');
  };

  const handleChange = (date: Nullable<Dayjs>): void => {
    onChange(date);
    validateField(date);
  };

  const handleBlur = (event: React.FocusEvent<HTMLElement, Element>): void => {
    const target = event.target as HTMLTextAreaElement;
    if (!value) {
      validateField(dayjs(target.value));
    }
    if (value) {
      validateField(value);
    }
  };

  const getCalculatedMinDate = (): Dayjs => {
    if (minDate) {
      return dayjs(minDate);
    } else if (minDateBirth && userData && userData.date_of_birth) {
      return dayjs(userData.date_of_birth);
    } else if (minDateToday) {
      return todayDay;
    } else {
      return hundredYearsAgo;
    }
  };

  const getCalculatedMaxDate = (): Dayjs => {
    if (maxDate) {
      return dayjs(maxDate);
    } else if (maxDateToday) {
      return todayDay;
    } else {
      return hundredYearsLater;
    }
  };

  return (
    <FormInputWrapper
      label={label}
      required={required}
      marginBottomNone
      disabled={disabled}
      className={classNames({
        'disabled-div': disabled,
      })}
    >
      <div className="form-input__date-box">
        <div className="edit-block">
          <div className="form-input_with-help-btn">
            <DatePicker
              id={name}
              name={name}
              placeholder={placeholder}
              value={value}
              format={format}
              onBlur={handleBlur}
              className={classNames('form-input__input form-control date-picker', {
                'error-input': !!inputError,
              })}
              minDate={getCalculatedMinDate()}
              maxDate={getCalculatedMaxDate()}
              onChange={handleChange}
            />
          </div>
        </div>
        {inputError && (
          <div className="error-msg error-msg-antd" key={inputError}>
            {inputError}
          </div>
        )}
      </div>
    </FormInputWrapper>
  );
};
